package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.StrategyW500Rounded: ImageVector
    get() {
        if (_strategyW500Rounded != null) {
            return _strategyW500Rounded!!
        }
        _strategyW500Rounded = Builder(name = "StrategyW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(193.54f, 429.24f)
                lineToRelative(-98.8f, -56.52f)
                quadTo(84.3f, 367.0f, 78.09f, 356.3f)
                quadToRelative(-6.22f, -10.69f, -6.22f, -23.13f)
                verticalLineToRelative(-112.56f)
                quadToRelative(0.0f, -12.44f, 6.22f, -23.13f)
                quadToRelative(6.21f, -10.7f, 16.65f, -16.41f)
                lineToRelative(98.8f, -56.53f)
                quadToRelative(10.2f, -5.71f, 22.63f, -5.71f)
                quadToRelative(12.44f, 0.0f, 22.63f, 5.71f)
                lineToRelative(98.81f, 56.53f)
                quadToRelative(10.43f, 5.71f, 16.65f, 16.41f)
                quadToRelative(6.22f, 10.69f, 6.22f, 23.13f)
                verticalLineToRelative(112.56f)
                quadToRelative(0.0f, 12.44f, -6.22f, 23.13f)
                quadToRelative(-6.22f, 10.7f, -16.65f, 16.42f)
                lineToRelative(-98.81f, 56.52f)
                quadToRelative(-10.19f, 5.72f, -22.63f, 5.72f)
                quadToRelative(-12.43f, 0.0f, -22.63f, -5.72f)
                close()
                moveTo(216.17f, 339.87f)
                lineTo(271.87f, 308.26f)
                verticalLineToRelative(-62.74f)
                lineToRelative(-55.7f, -31.61f)
                lineToRelative(-55.69f, 31.61f)
                verticalLineToRelative(62.74f)
                lineToRelative(55.69f, 31.61f)
                close()
                moveTo(668.13f, 481.52f)
                verticalLineToRelative(-102.8f)
                lineToRelative(94.74f, 55.89f)
                quadToRelative(21.39f, 12.43f, 33.33f, 33.32f)
                quadToRelative(11.93f, 20.9f, 11.93f, 45.0f)
                verticalLineToRelative(180.35f)
                quadToRelative(0.0f, 24.11f, -11.93f, 45.0f)
                quadToRelative(-11.94f, 20.89f, -33.33f, 33.33f)
                lineToRelative(-153.3f, 89.41f)
                quadToRelative(-21.4f, 12.44f, -45.74f, 12.44f)
                quadToRelative(-24.35f, 0.0f, -45.74f, -12.44f)
                lineToRelative(-153.31f, -89.41f)
                quadToRelative(-21.39f, -12.44f, -33.32f, -33.33f)
                quadToRelative(-11.94f, -20.89f, -11.94f, -45.0f)
                verticalLineToRelative(-180.35f)
                quadToRelative(0.0f, -24.1f, 11.94f, -45.0f)
                quadToRelative(11.93f, -20.89f, 33.32f, -33.32f)
                lineToRelative(94.74f, -55.89f)
                verticalLineToRelative(102.8f)
                lineToRelative(-51.39f, 29.98f)
                verticalLineToRelative(183.22f)
                lineToRelative(155.7f, 90.37f)
                lineToRelative(155.69f, -90.37f)
                lineTo(719.52f, 511.5f)
                lineToRelative(-51.39f, -29.98f)
                close()
                moveTo(608.13f, 320.48f)
                verticalLineToRelative(195.69f)
                quadToRelative(0.0f, 18.68f, -12.81f, 31.49f)
                quadToRelative(-12.82f, 12.82f, -31.49f, 12.82f)
                quadToRelative(-18.68f, 0.0f, -31.49f, -12.82f)
                quadToRelative(-12.82f, -12.81f, -12.82f, -31.49f)
                verticalLineToRelative(-398.8f)
                quadToRelative(0.0f, -19.15f, 13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(238.07f)
                quadToRelative(27.34f, 0.0f, 40.78f, 23.87f)
                quadToRelative(13.43f, 23.87f, -2.24f, 46.74f)
                lineToRelative(-19.22f, 28.59f)
                quadToRelative(-7.95f, 11.43f, -7.95f, 25.1f)
                quadToRelative(0.0f, 13.68f, 7.95f, 25.11f)
                lineToRelative(19.22f, 28.59f)
                quadToRelative(15.67f, 22.87f, 2.24f, 46.74f)
                quadToRelative(-13.44f, 23.87f, -40.78f, 23.87f)
                lineTo(608.13f, 320.48f)
                close()
                moveTo(563.83f, 633.3f)
                close()
                moveTo(216.17f, 276.89f)
                close()
            }
        }
        .build()
        return _strategyW500Rounded!!
    }

private var _strategyW500Rounded: ImageVector? = null
